<template>
  <div>
    <embedded-spinner :show="subscriberDataInProgress" />
    <div v-if="subscriberData">
      <full-view-spinner :show="inProgress" />
      <br>
      <checkbox
        id="marketingFlagCheckbox"
        ref="marketingFlagCheckbox"
        name="marketingFlagCheckbox"
        :initial-value="marketingFlag"
        :on-click="updateMarketing"
      >
        <p>
          {{ this.$i18n.t('MANAGE.SUBSCRIBER_DATA.MARKETING') }}
          <br>
          {{ this.$i18n.t('MANAGE.SUBSCRIBER_DATA.MARKETING_INFO') }}
        </p>
      </checkbox>
    </div>
  </div>
</template>

<script>

const RESP_VALIDATION_ERROR = 1;
const RESP_IN_PROGRESS = 2;
const RESP_OTHER_ERROR = 9999;

export default {
  name: 'MarketingCheckbox',
  components: { },
  data: function() {
    return {
      inProgress: false,
    }
  },
  computed: {
    subscriberData: function() {
      return this.$store.getters['subscriber/subscriberData'];
    },
    subscriberDataInProgress: function() {
      return this.$store.getters['subscriber/inProgress'];
    },
    marketingFlag: function() {
      if (this.subscriberData) {
        return this.subscriberData.marketingFlag;
      } else {
        return null;
      }
    },
  },
  mounted: function() {
    this.$store.dispatch("subscriber/refreshSubscriberData", this.$http);
  },
  methods: {
      updateMarketing: function() {
        if (!this.inProgress) {
          this.inProgress = true;
          this.marketingChangeRequest = {
            msisdn: this.$store.getters.userDetail.msisdn,
            changeTo: this.$refs.marketingFlagCheckbox.getValue(),
          };
          this.$http.post('api/user/marketingChange', this.marketingChangeRequest)
            .then( (response) => {
              this.$store.commit("setSuccessMessage", this.$i18n.t('MARKETING.SUCCESS'));
              this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Marketing checkbox',label: 'Success', value: 0, noninteraction: false });
            })
            .catch(callData => {
              this.processErrorCallResponse(callData);
            })
            .finally(() => {
              this.inProgress = false;
            })
        }
      },
      processErrorCallResponse: function(callData) {
        this.$refs.marketingFlagCheckbox.setValue(!this.$refs.marketingFlagCheckbox.getValue());

        if(callData.response === undefined || callData.response.data === undefined) {
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Marketing checkbox',label: 'Error - no data', value: 0, noninteraction: false });
          return;
        }

        let responseCode = callData.response.data.responseCode;

        switch(responseCode) {
          case RESP_VALIDATION_ERROR:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Marketing checkbox',label: 'Error - validation', value: 0, noninteraction: false });
            break;
          case RESP_IN_PROGRESS:
            this.$store.commit("setWarningMessage", this.$i18n.t('MARKETING.IN_PROGRESS'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Marketing checkbox',label: 'Error - in progress', value: 0, noninteraction: false });
            break;
          case RESP_OTHER_ERROR:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Marketing checkbox',label: 'Error - technical issue', value: 0, noninteraction: false });
            break;
          default:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Marketing checkbox',label: 'Error - '+responseCode, value: 0, noninteraction: false });
          }
      },
  }
}
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
